export default function SocietesConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('societes');
}

SocietesConfiguration.$inject = ['$translatePartialLoaderProvider'];
